// src/components/project/SKIPER/chapters/Prototipes.jsx
import React from 'react';
import traccion from '../../../../images/traccion.JPG';
import compresion from '../../../../images/compresion.jpg';
import aleta1 from '../../../../images/aleta1.JPG';

export default function Prototipes() {
  return (
    <section
      id="prototipes-content"
      className="chapter-section content-section"
    >
      <div className="chapter-content">
        <h1 className="content-title">Prototypes</h1>
        <p>
          Developing SKIPER has not being a one-shot success.
        </p>
        <img src={aleta1} alt="aleta1" className="chapter-image"/>

        <p>
          Early prototypes focused on movement through pneumatic actuation, using silicone molds and flexible resin prints to simulate the undulating motion of aquatic life. As the project evolved,
           they experimented with mechanical systems: 3D-printed fins featuring vertebrae-like structures and segmented articulations enabled by string or cable-driven control.
        </p>
        <img src={traccion} alt="traccion" className="chapter-image"/>

        <p>
          To test durability and performance, the team designed specialized specimens for tensile and compression testing,
          gathering data essential for selecting materials suited to the harsh Antarctic environment. 
          Drawing inspiration from aerodynamic wing profiles, they created 3D fin models — even fabricating ceramic prototypes to evaluate fluid dynamics under controlled conditions.
        </p>
        <img src={compresion} alt="compresion" style={{ width: '30%', height: 'auto' }} className="chapter-image"/>
        <p>
          Each iteration brought SKIPER closer to becoming a functional, reliable research tool. Through a blend of engineering, biology, and design, 
          Hero Dynamics continues to develop technology that mimics nature without disrupting it — making SKIPER a promising asset for environmental science.
        </p>


      </div>
    </section>
  );
}
